const rateCards = [
  { item: "Incentive (custom)", price: 0.0 },
  { item: "In house: projectmanagement", price: 450.0 },
  { item: "incentive", time: 45, location: "on location", price: 55 },
  { item: "incentive", time: 60, location: "on location", price: 75 },
  { item: "incentive", time: 75, location: "on location", price: 95 },
  { item: "incentive", time: 45, location: "remote", price: 40 },
  { item: "incentive", time: 60, location: "remote", price: 60 },
  { item: "incentive", time: 75, location: "remote", price: 75 },
  { item: "werving", complexity: "simpel", price: 75 },
  { item: "werving", complexity: "basic", price: 100 },
  { item: "werving", complexity: "extra", price: 150 },
  { item: "werving", complexity: "complex", price: 200 },
  {
    item: "Incentive (75-100 min. carrousel/speeddate op locatie)",
    price: 100.0,
  },
  { item: "Incentive (75-100 min. carrousel/speeddate remote)", price: 75.0 },
  { item: "Incentive (eind interview dagboekstudie)", price: 20.0 },
  { item: "Incentive (eind interview dagboekstudie)", price: 30.0 },
  { item: "Loop11", price: 250.0 },
  { item: "Optimal Workshop", price: 250.0 },
  { item: "Pop-up Lab", price: 1500.0 },
  { item: "Reiskosten", price: 15.0 },
  { item: "Reiskosten - Remote onderzoek niet doorbelasten", price: 0.0 },
  { item: "Remote Lab", price: 950.0 },
  { item: "Remote lab + Avond", price: 1400.0 },
  { item: "Respondent", complexity: "basic", price: 100.0 },
  { item: "Respondent", complexity: "complex", price: 200.0 },
  { item: "Respondent", complexity: "extra", price: 150.0 },
  { item: "Respondent", complexity: "simpel", price: 75.0 },
];

export default rateCards;
